import React, { Fragment } from "react";
import {
  Modal,
  ModalFooter,
  ModalInput,
  ModalButton,
  ModalBody,
  modalConnect,
} from "@modal";
import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";

import {
  ceModalUploadAttachmentLoadFile,
  ceModalUploadAttachmentCancel,
  ceModalUploadAttachmentSave,
  ceModalUploadAttachmentOpenFilePicker,
  ceModalUploadAttachmentCancelFilePicker,
} from "@js/actions/studio/campaign_content_section/modal_upload_attachment.js";

import { humanReadableSize } from "@js/helpers/text_format.js";

import { Base64 } from 'js-base64';

const ModalUploadAttachment = modalConnect((props) => {
  let updateFileFromInput = (e) => {
    props.dispatch(ceModalUploadAttachmentOpenFilePicker());
    let startTime = Date.now();
    let fileObject = e.target.files[0];
    let attachment_name = "";

    if (e.target.value.indexOf("/") > -1) {
      attachment_name = e.target.value.split("/").reverse()[0];
    } else {
      attachment_name = e.target.value.split(`\\`).reverse()[0];
    }

    if (fileObject) {
      let reader = new FileReader();
      reader.onload = (loadedReader) => {
        let loadedTime = Date.now();
        let dataBase64 = loadedReader.target.result.replace(/^data:.*?;base64,/, "");
        let size = Base64.atob(dataBase64).length;

        if (loadedTime - startTime < 500) {
          // Always wait a minimum of 0.5 seconds to avoid flashing
          let timeRemaining = 500 - (loadedTime - startTime);
          setTimeout(() => {
            props.dispatch(
              ceModalUploadAttachmentLoadFile(
                attachment_name,
                dataBase64,
                size,
              ),
            );
          }, timeRemaining);
        } else {
          props.dispatch(
            ceModalUploadAttachmentLoadFile(
              attachment_name,
              dataBase64,
              size,
            ),
          );
        }
      };
      reader.readAsDataURL(fileObject);
    } else {
      // User cancelled, no file object present
      props.dispatch(ceModalUploadAttachmentCancelFilePicker());
    }
  };

  return (
    <Modal
      title={t("buttons.attach_a_file_to_this_campaign")}
      onCancel={() => props.dispatch(ceModalUploadAttachmentCancel())}
    >
      <ModalBody>
        <ModalInput
          type="file"
          onChange={updateFileFromInput}
          error={props.validation_error}
        />
        {props.attachment_name && (
          <small>
            {t("phrases.react_content.selected_file")}: {props.attachment_name}{" "}
            ({humanReadableSize(props.size)})
          </small>
        )}
      </ModalBody>

      <ModalFooter>
        {props.picker_is_open ? (
          <LoadingSpinner width="25px" height="25px" />
        ) : (
          <Fragment>
            <ModalButton
              onClick={() => props.dispatch(ceModalUploadAttachmentCancel())}
              text={t("buttons.cancel")}
              diminished
            />
            <ModalButton
              onClick={() => props.dispatch(ceModalUploadAttachmentSave())}
              text={t("phrases.react_content.attach_file")}
              dangerous={props.validation_error}
            />
          </Fragment>
        )}
      </ModalFooter>
    </Modal>
  );
});

export default ModalUploadAttachment;
